import { isPlainObject } from '@srcDS/utils/assertions';
import { ConfigurationSchema } from '@frontastic/common';

export const usePageMetadata = (context, node) => {
  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  const countryName = context.locale === 'en_AU@NZD' ? 'New Zealand' : 'Australia';

  const projectSchema = new ConfigurationSchema(
    context.projectConfigurationSchema,
    context.projectConfiguration
  );

  const pageTitleSuffixSchema = projectSchema.get('frontasticPageTitleSuffix');
  const pageTitleSuffix =
    pageTitleSuffixSchema?.[context.locale] ||
    pageTitleSuffixSchema?.['en_AU@AUD'] ||
    pageTitleSuffixSchema;

  const pageFallbackDescriptionSuffix = !isPlainObject(projectSchema.get('pageFallbackDescriptionSuffix'))
    ? projectSchema.get('pageFallbackDescriptionSuffix')
    : projectSchema.get('pageFallbackDescriptionSuffix')?.[context.locale];

  const pageTitleIsSetOnNode = node.configuration?.seoTitle?.length > 0 && typeof node.configuration?.seoTitle !== 'undefined';
  const pageDescriptionIsSetOnNode = node.configuration?.seoDescription?.length > 0 && typeof node.configuration?.seoDescription !== 'undefined';

  return {
    locale,
    countryName,
    pageTitleSuffix,
    pageFallbackDescriptionSuffix,
    pageTitleIsSetOnNode,
    pageDescriptionIsSetOnNode
  };
};